export const ROUTES = {
  BUSINESS_HOME: "/business",
  BUSINESS_CARS: "/business/cars",
  BUSINESS_ANALYTICS: "/business/analytics",
  BUSINESS_ORDERS: "/business/analytics/orders",
  BUSINESS_DOCS: "/business/analytics/documents",
  SERVICE_CENTERS: "/prototypes/contractors/service-centers",
  SERVICE_CENTER_DETAIL: "/prototypes/contractors/service-centers/:uuid",
  CLIENTS: "/prototypes/clients",
  CLIENT_DETAIL: "/prototypes/clients/:uuid",
  PUSH_CAMPAIGNS: "/prototypes/push-campaigns",
  PUSH_CAMPAIGN_NEW: "/prototypes/push-campaigns/new",
  PUSH_CAMPAIGN_EDIT: "/prototypes/push-campaigns/:uuid/edit",
  PUSH_CAMPAIGN_DETAIL: "/prototypes/push-campaigns/:uuid",
  HELP: "/prototypes/help",
  HELP_SETTINGS: "/prototypes/help/settings",
  DISCOUNTS: "/prototypes/discounts",
  DISCOUNT_NEW: "/prototypes/discounts/new",
  DISCOUNT_DETAIL: "/prototypes/discounts/:uuid",
  DISCOUNT_USAGES: "/prototypes/discounts/usages",
  // Keys used by the moved prototype pages
  PROTO_SERVICE_CENTERS: "/prototypes/contractors/service-centers",
  PROTO_SERVICE_CENTER_DETAIL: "/prototypes/contractors/service-centers/:uuid",
  PROTO_CLIENTS: "/prototypes/clients",
  PROTO_CLIENT_DETAIL: "/prototypes/clients/:uuid",
  PROTO_HELP: "/prototypes/help",
  PROTO_HELP_SETTINGS: "/prototypes/help/settings",
} as const;
